import {Component, OnDestroy, OnInit} from '@angular/core';
import {EnumerationService} from '../enumeration/enumeration.service';
import {Owner} from './owner.model';
import {UIRouter} from '@uirouter/angular';
import {OwnerService} from './owner.service';
import {ContactService} from '../contact/contact.service';
import {UserService} from '../user/user.service';
import {Contact} from '../contact/contact.model';
import {CombiFormComponent} from '../shared/combi-form.component';
import {TranslateService} from '@ngx-translate/core';
import {RoutePrefix} from '../shared/route-prefix';

@Component({
  selector: 'app-owner-form-component',
  templateUrl: './owner-form.component.html'
})
export class OwnerFormComponent extends CombiFormComponent implements OnInit, OnDestroy {
  public owner: Owner = new Owner();
  public contacts: Contact[] = [];
  public formTitle: string;
  public routePrefix: RoutePrefix;
  public countries: string[] = [];

  constructor(
    protected router: UIRouter,
    private ownerService: OwnerService,
    private contactService: ContactService,
    private translate: TranslateService,
    private enumService: EnumerationService
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.enumService.get('country').subscribe((countries: string[]) => {
      this.countries = countries;
    });

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('owner.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE: {
        this.routePrefix = {
          entity: 'owner',
          entityId: this.router.stateService.params[this.stateIdParam]
        };

        this.translate.get('owner.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.contactService.setRoutePrefix(`${Owner.name.toLowerCase()}/${this.router.stateService.params.id}`);
        this.contactService.getAll().subscribe((contacts: Contact[]) => {
          this.contacts = contacts;
        });

        this.ownerService.get(this.router.stateService.params[this.stateIdParam]).subscribe((owner: Owner) => {
          this.owner = owner;
        });
      } break;
    }
  }

  public ngOnDestroy(): void {
    this.contactService.clearRoutePrefix();
  }

  public save() {

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.ownerService.add(this.owner).subscribe((owner: Owner) => {
          this.router.stateService.go('owner.edit.contact', {id: owner.id}, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE: {
        this.ownerService.update(this.owner).subscribe((result) => {
          this.router.stateService.go('owner', null, {reload: true});
        });
      } break;
    }

  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/owner/owner-form.component.ts